export default function LocationSection() {
  return (
    <section id="location" className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Our Reach
            </span>
            <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
              Serving placement agencies <span className="italic text-primary-600">across the Niagara Region</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed text-base md:text-lg mb-8">
              We partner with Children&apos;s Aid Societies, developmental service organizations, community agencies, and government-funded programs throughout the Niagara Region and surrounding areas.
            </p>
            <div className="space-y-3">
              {[
                'Head office and residential homes in the Niagara Region',
                '24-hour response to all placement inquiries',
                'Available for emergency and planned placements',
              ].map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line"></i>
                  </span>
                  <span className="text-foreground-700 text-sm leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-background-200/70 h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2917.1!2d-79.0849!3d43.0896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d3633d1e5d3c6b%3A0x7a2bdcb4f1f1f1f1!2sNiagara+Falls%2C+ON!5e0!3m2!1sen!2sca!4v1752650000!5m2!1sen!2sca"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MCT Residential Services - Niagara Region Service Area"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}